import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  AfterViewInit,
} from "@angular/core";
import { FormDoc } from "../../../core/models/physician/form-doc";
import { FormFolder } from "../../../core/models/physician/form-folder";

@Component({
  selector: "app-form-edit-folder",
  templateUrl: "./form-edit-folder.component.html",
  styleUrls: ["./form-edit-folder.component.scss"],
})
export class FormEditFolderComponent implements OnInit, AfterViewInit {
  @Input() sectionName: string;
  @Output() close = new EventEmitter();
  @Input() sidebarOpened: boolean;
  @Input() formFolders: FormFolder[];
  @Input() formDocument: FormDoc;
  @Output() toggleEvent = new EventEmitter();

  @Input() sideBarHeader: string = "Folders";

  constructor() {}

  ngOnInit() {}
  ngAfterViewInit() {
    this.setSidebarHeader();
  }
  setSidebarHeader() {
    switch (this.sectionName) {
      case "managefolders":
        this.sideBarHeader = "Folders";
        break;
      case "addtofolders":
        this.sideBarHeader = "Add to Folder";
        break;
    }
  }

  closeSidebar(): void {
    //this.sidebarOpened = false;
    this.close.emit();
  }

  togglePopUp(formFolders: FormFolder[]) {
    this.toggleEvent.emit(formFolders);
  }
}
